// extracted by mini-css-extract-plugin
module.exports = {"body":"about-module--body--xmZOA"};